export default "__VITE_ASSET__e26eb429__"